var Handlebars = require("../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "        <i class=\"fr-revert-shape-position icon-undo "
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showRevertBtn : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" title=\"Revert Shape Position\" tabindex=\"0\"></i>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "hide";
},"4":function(container,depth0,helpers,partials,data) {
    return "        <i title=\"Expand/Collapse\"\n           class=\"icon fr-page-toggle-collapse-icon collapsible-btn\" tabindex=\"0\"></i>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "checked";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "\n    <td class=\"fr-td-preview\" data-region=\"true\" "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.showZonePropertiesColumn : depth0),{"name":"unless","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "></td>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showZonePropertiesColumn : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "colspan=\"2\"";
},"11":function(container,depth0,helpers,partials,data) {
    return "\n        <td class=\"fr-td-more-btn\">\n\n            <button class=\"fr-hit-more-btn btn\" title=\"Zone Properties...\">\n                <i class=\"icon-ellipsis-vert\"></i>\n            </button>\n            <!-- currently not used <div class=\"fr-zone-prop-holder\" data-region=\"true\"></div> -->\n\n        </td>\n\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "\n    <td class=\"fr-td-content-col\" colspan=\"2\">\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHeaderRow : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSearchRow : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isPageRow : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n        <div class=\"fr-page-hit-count-region\" data-region=\"true\"></div>\n\n    </td>\n\n";
},"14":function(container,depth0,helpers,partials,data) {
    var helper;

  return "            <span>"
    + container.escapeExpression(((helper = (helper = helpers.rowHeader || (depth0 != null ? depth0.rowHeader : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rowHeader","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            <span>Search \""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.search : depth0), depth0))
    + "\"</span>"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.pageNumber : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"17":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return ": <a class=\"fr-page-link\" href=\"Page "
    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
    + "\" title=\"Go to page "
    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
    + "\" role=\"button\">Page "
    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
    + "</a>\n";
},"19":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "            <a class=\"fr-page-link\" href=\"Page "
    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
    + "\" title=\"Go to page "
    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
    + "\" role=\"button\">Page "
    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
    + "</a>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<td class=\"fr-td-page-toggle-collapse\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHitRow : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "\n</td>\n\n\n<td class=\"fr-td-include\">\n    <input class=\"fr-select-hit-cb\" title=\"Include\" type=\"checkbox\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isApplied : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n</td>\n\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHitRow : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(13, data, 0),"data":data})) != null ? stack1 : "")
    + "\n\n\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/baseRowView/template.hbs
 ** module id = 624
 ** module chunks = 0
 **/